import { Outlet } from 'react-router-dom';

import { usePermissions } from '@/hooks/usePermissions';

import { visibleProfileTabs } from './companyProfileTabs';
import { RouteTabs } from './RouteTabs';

/** Tab row above whichever of the three pages is open. */
export function CompanyProfileSection() {
  const { can } = usePermissions();

  return (
    <div>
      <RouteTabs label="Company profile" tabs={visibleProfileTabs(can)} />
      <Outlet />
    </div>
  );
}
